module.exports = __webpack_public_path__ + "img/gb810.prt.f791b701.jpg";